import styled from "styled-components";
import type { ReactNode, } from "react";


export declare type SwapInputsContainerProps = {
  children: ReactNode;
};

export const SwapInputsContainer = ({ children }: SwapInputsContainerProps) => {
  return <Container>{children}</Container>;
};


const Container = styled.div`
  display: flex;
  flex-direction: column;
	gap: 1rem;

	@media(max-width: 1024px) {
  	gap: 0.75rem;
	}
`;
